export default "__VITE_ASSET__Cxdo$Plr__"